import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { DomainConf } from './DomainSwitchConfig';

export const appConfig = {

    "lskey": "riverpoker",
    "wsessionIdKey": "wsessionBD",
    siteId: DomainConf.getDomainConfigData().siteId,
    "captchaInfoKey": "captchainfokey",
    "countriesDataKey": "countriesData",
    "preferredCurrency": DomainConf.getDomainConfigData().currency,
    "Userdatakeyforcookie": "USER_DATA",
    "minAgeForBday": 18,
    nothingToDisplayMsg: "No value",
    paymentMethod: 304,
    bonuscode: "",
    rowPerPage: 99,
    defaultRoute: "home",
    appLanguages: [{ langid: "en", langname: "English" }, { langid: "fr", langname: "French" }],
    currentLanguageKey: "i18nlangkey",
    defaultLanguage: "en",
    vipPointsKey: "VIP Points",
    htmlGames: ["BLACKJACK", "EUROPEANROULETTE", "BACCARAT", "JACKSORBETTER"],
    turnOnFilterForHtmlGames: true,



    providers: [provideRouter(routes)],

    sideMenu: [
        {
            displayName: "PROFILE",
            link: "/profile",
            selected: false
        },
        {
            displayName: "MY_BALANCE",
            link: "/mybalance",
            selected: false
        },
        {
            displayName: "DEPOSIT",
            link: "/deposit"
            , selected: false,
            condition: "deposits"
        },
        // {
        //     displayName: "Exchange",
        //     link: "/exchange-currency",
        //     selected: false
        // },
        {
            displayName: "CASHOUT",
            link: "/cashout",
            selected: false,
            condition: "withdrawal"
        },
        // {
        //     displayName: "PendingWithdrawal",
        //     link: "/pending-cashout",
        //     selected: false
        // },
        // {
        //     displayName: "Bank Account", 
        //     link: "/bank" ,
        //     selected: false 
        // }, 
        {
            displayName: "TRANSACTION_HISTORY",
            link: "/transactionhistory"
            , selected: false
        },
        {
            displayName: "GAME_HISTORY",
            link: "/casinogamehistory"
            , selected: false
        },
    ]
};
